import { translate, translateOptional } from "@/i18n/translate";

/**
 * Text of a backend code (photo-quality reasons such as "pizza_blurred", statuses OK / NOK) in the current
 * language. Codes without a translation are shown beautified ("some_reason" -> "Some Reason").
 */
export function t(key: string | undefined | null): string {
  if (!key) return "";

  if (key === "OK") return translate("status.ok");
  if (key === "NOK") return translate("status.nok");
  if (key === "WARNING") return translate("status.warning");

  const translated =
    translateOptional(`photoReason.${key}`) ?? translateOptional(`photoReason.${key.toLowerCase()}`);
  if (translated !== undefined) return translated;

  return key.replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase());
}
